function buildCustomerInteractionUrl(params) {
  const segments = [
    "performance",
    "playbooks",
    params.playbookId,
    "customer-interactions",
    params.gradingId
  ];
  const search = new URLSearchParams();
  const { target } = params;
  if (target?.tab === "assessment") {
    segments.push("assessment");
    if (target.criterionId) {
      segments.push("criteria", target.criterionId);
    }
  } else if (target?.tab === "transcript") {
    segments.push("transcript");
    if (target.quote) {
      search.set("quote", target.quote);
    }
  }
  const path = `/${segments.map(encodeURIComponent).join("/")}`;
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}
export {
  buildCustomerInteractionUrl
};
//# sourceMappingURL=customerInteractionUrl.js.map
